import { CEO_LEVEL, ROLES, ROLE_LIST } from "./roles";

// Helpers used by module files to declare who holds a permission.
// `lud(...)` always includes ceo / cto / developer (full access);
// `only(...)` is for the few permissions that deliberately exclude them.
export const lud = (...roles) => [...CEO_LEVEL, ...roles];
export const only = (...roles) => [...roles];
// Every role that can be inside the app (i.e. everyone but `new`) except the
// listed ones. Used for the old "role is NOT x" checks.
export const everyoneBut = (...excluded) =>
  ROLE_LIST.filter((role) => role !== ROLES.NEW && !excluded.includes(role));

/**
 * @typedef {Object} Rule
 * @property {string[]} roles           roles that hold the permission
 * @property {"restaurant"|"branch"} [scope]  resource scope that must also pass
 * @property {boolean} [requiresBranch]  a `branch` user needs at least one valid assigned branch (NA-035);
 *           other roles are never affected, whatever branches they have
 * @property {(ctx: {role: string, user: object, resource: object}) => boolean} [when]
 *           extra condition (e.g. document category), evaluated after the role
 */
export const rule = (roles, extra = {}) => ({ roles, ...extra });
